export default __webpack_public_path__ + "static/media/sale5.c68b4333.png";